import { JSEncrypt } from 'jsencrypt'
// import { CryptoJS } from 'crypto'
const CryptoJS = require('crypto-js');

 function encryptByDES(msg, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const encrypted = CryptoJS.DES.encrypt(msg, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

 function deEncryptByDES(ciphertext, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const deEncrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
  )
  return deEncrypted.toString(CryptoJS.enc.Utf8)
}

 function encryptByTripleDES(msg, key) {
  // 如果3DES加密使用Utf8,则java端解密时候需要String jsonData = new String(SecurityUtils.tripleDESDecrypt(Base64.decodeBase64(json.get("jsonData").toString()), desKeyDecoded.getBytes()), "UTF-8")
  // const keyHex = CryptoJS.enc.Utf8.parse(key)
  // 如果3DES加密使用Base64,则java端解密时候需要String jsonData = new String(SecurityUtils.tripleDESDecrypt(Base64.decodeBase64(json.get("jsonData").toString()), desKeyDecoded), "UTF-8")
  // 解密处理器DecryptFilter
  const keyHex = CryptoJS.enc.Base64.parse(key)
  const encrypted = CryptoJS.TripleDES.encrypt(msg, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

 function deEncryptByTripleDES(ciphertext, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const deEncrypted = CryptoJS.TripleDES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
      },
      keyHex,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
  )
  return deEncrypted.toString(CryptoJS.enc.Utf8)
}

 function genDynamicDESKey(length) {
  length = length || 32
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  const maxPos = chars.length
  let key = ''
  for (let i = 0; i < length; i++) {
    key += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return key
}

const PUBLIC_KEY =
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhFxwi3mmotlLX4rRcjeT6BI8HrWz8d8IkjexVZNp98pQjQfTCHujydqWVTQHJJy988Sx7hoWS+BhEGxBpeXFM4Fxp50RNPa6mVAgaBEUhls4uM+dqzahWSHese9PWUhnenTHhh1y8oBBktZhwbpVGml3/VVgWTeDdHtyelfUjItk8BqKJox10Ool+bpj/kt+ERgWcKtoaUYeNNC9i/zA8OtNVPr9JW2KoCyiPRlagUKtcO4kwv/LPolfKdRjDYjPLPkXYDv6ThZfeKZ9yVvJfL3t410BZMNJ/RYHHLwGv+43v3fGQTeGmRmVcpv+r96wk5Ac8/tBuqoA2FPuhBRACwIDAQAB'
const encrypt = new JSEncrypt()
encrypt.setPublicKey(
  '-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----'
)

 function rsaEncrypt(msg) {
  return encrypt.encrypt(msg)
}

const password = genDynamicDESKey(32)

export const desParam = (data) => {
  return encryptByTripleDES(JSON.stringify(data), password);
}
export const getDesKey = () => {
    return rsaEncrypt(password)
}